<template>
  <Main>
    <QuotationEditForm
      :form="currentQuotationToEdit"
      @submit="submit"
      @return="previousPage"
      v-if="show"
    >
      <v-row>
        <v-col cols="12" class="py-8">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <p class="primary--text form__title">
            SEGURADORA SELECIONADA
          </p>
          <v-row>
            <v-col cols="5">
              <v-row
                class="py-2 px-4 align-center edit-draft-contract__flex-row edit-draft-contract__content"
              >
                <v-col
                  cols="12"
                  md="auto"
                  class="edit-draft-contract__flex-col"
                >
                  <v-avatar class="edit-draft-contract__img">
                    <img :src="currentQuotationToEdit.minuta.seguradora.logo" />
                  </v-avatar>
                  <p
                    class="mb-0 lightestGray--text edit-draft-contract__name d-inline-block pl-3"
                  >
                    {{ currentQuotationToEdit.minuta.seguradora.nome }}
                  </p>
                </v-col>
                <v-divider vertical inset class="d-none d-md-flex" />
                <v-col
                  cols="12"
                  md="auto"
                  class="edit-draft-contract__flex-col text-center"
                >
                  <p class="primary--text mb-0 d-inline-block">
                    R$
                  </p>
                  <p
                    class="edit-draft-contract__money mb-0 primary--text d-inline-block pl-1"
                  >
                    {{
                      asMoneyString(
                        currentQuotationToEdit.minuta.valor
                      ).replace("R$", "")
                    }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-9 pb-7">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.comentario"
            :rules="[maxLengthTextArea]"
            label-text="Incluir Comentário"
          />
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar documentos (se necessários)
          </p>
          <DropFile @selected-files="addFiles" :multiple="true" class="mb-5" />
          <DocumentDataTable
            v-if="form.anexos"
            :documents="form.anexos"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
        </v-col>
      </v-row>
    </QuotationEditForm>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="MINUTA EDITADA"
      text="Minuta foi editada com sucesso"
    />
  </Main>
</template>
<script>
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import QuotationEditForm from "../components/QuotationEditForm";
import { asMoneyString } from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import { maxLengthTextArea } from "@/utils/rules.js";
export default {
  data: () => ({
    modal: false,
    form: {
      comentario: null,
      anexos: []
    },
    show: false,
    asMoneyString,
    maxLengthTextArea
  }),
  components: {
    DropFile,
    DocumentDataTable,
    QuotationEditForm,
    ModalGenericCriticism
  },
  mixins: [QuotationMixin, LoadingRequest, DocumentsMixin],
  created() {
    this.fetchEditQuotation();
  },
  computed: {
    ...mapState("quotation", ["currentQuotationToEdit"])
  },
  methods: {
    ...mapActions("quotation", [
      "requestEditQuotation",
      "requestCurrentQuotationToEdit"
    ]),
    fetchEditQuotation() {
      this.withLoading(
        this.requestCurrentQuotationToEdit(this.$route.params.id)
      );
    },
    async submit(form) {
      let payload = _.cloneDeep(form);
      payload.anexos = await this.submitFiles(payload.anexos);
      payload.comentario = this.form.comentario;
      this.withLoading(
        this.requestEditQuotation(
          await this.getEditPayload(payload, this.$route.params.id)
        ).then(() => {
          this.modal = true;
        })
      );
    },
    submitFiles() {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(this.form.anexos, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => arquivo)
        )
      );
    },
    addFiles(files) {
      this.form.anexos = this.form.anexos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item) {
      this.form.anexos = this.form.anexos.filter(
        document => document.nome !== item.nome
      );
    },
    previousPage() {
      this.modal = false;
      this.$router.push({
        name: "quotation element",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    currentQuotationToEdit(value) {
      this.show = true;
      this.form = _.cloneDeep(value);
    }
  }
};
</script>
<style lang="sass">
.edit-draft-contract__
  &content
    border: 1px solid #D5D5E0 !important
    border-radius: 4px
    background-color: #FFFFFF
  &flex-col
    @media(max-width:960px)
      justify-content: center
      align-items: center
      display: flex
    @media(min-width:960px)
      flex: 1
  &flex-row
    @media(min-width:960px)
      display: flex
      flex-wrap: wrap
  &money
    font-size: 20px
    font-weight: 800
  &name
    font-size: 13px
    font-weight: 600
  &img
    border: 1px solid #D5D5E0
    background-color: #FFFFFF
</style>
